import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import styled from 'styled-components';
import { CTA, Modal } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';

const ImageWrapper = styled.div`
  width: 100%;
  padding-bottom: 56.25%;
  position: relative;
`;

const Img = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${({ url }) => url});
  background-position: center center;
  background-size: cover;
`;

export const ModalPreviewMediaId = 'ModalPreviewMedia';

const ModalPreviewMedia = ({ mediaIsPhone, payload, modalClose }) => {
  const scrollableAreaRef = useRef(null);

  return (
    <Modal
      title="Visualizza anteprima"
      modalId={ModalPreviewMediaId}
      scrollableAreaRef={scrollableAreaRef}
    >
      <ScrollableArea ref={scrollableAreaRef} style={{ minWidth: '80vw' }}>
        <ImageWrapper>
          <Img url={payload?.url} />
        </ImageWrapper>
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="Chiudi"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
      </Footer>
    </Modal>
  );
};

ModalPreviewMedia.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  payload: PropTypes.object,
  // dispatch
  modalClose: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { payload } = state.app.modal;
      return { payload };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
    })
  ),
  withMediaQueries
)(ModalPreviewMedia);
